define('gigaset_recurring/components/checkout/provider/billwerk/finalize',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/components/PubSubHub",
	"cartware/jquery/bem",
	"cartware/components/Config",
	"gigaset_recurring/classes/bridge",
	"gigaset_recurring/classes/provider/billwerk/loader",
	"shoptheme/components/tracking"
], function(
	$,
	_,
	Component,
	PubSubHub,
	BEM,
	Config,
	Bridge,
	BillwerkLoader,
	Tracking
) {
	return Component.create({
		finalizeBlock: null,

		$init: function() {
			this.billwerk = {
				initialized: false,
				js: Config.get('recurring.provider.billwerk.js'),
				pubKey: Config.get('recurring.provider.billwerk.api.public_key'),
				returnUrl: Config.get('recurring.provider.billwerk.provider.url.return'),
				finalizeAfterUrl: Config.get('recurring.provider.billwerk.provider.url.finalizeAfter')
			};

			this.finalizeBlock = BEM.block("gigaset-recurring-payment-finalize");

			this.customer = Config.get('recurring.customer');

			BillwerkLoader.once("loaded", _.bind(this.onBillwerkJs, this));
			BillwerkLoader.load();
		},

		onBillwerkInitialized: function() {
			this.billwerk.initialized = true;
			this.finalize();
		},

		finalize: function() {
			var self = this;

			BillwerkJS.finalize(_.bind(function(resultObject) {
				var contractId = resultObject.ContractId;

				this.logger.debug("Finalizing order succeeded", resultObject);

				$.post(self.billwerk.finalizeAfterUrl, { contractId: contractId })
					.always(_.bind(this.handleOrderComplete, this))
					.fail(_.bind(function(xhr) {
						this.logger.error("Error saving contract data to order");
					}, this));
			}, this), _.bind(function(errorObject) {
				this.logger.error("Finalizing order failed", errorObject);
				this.handleOrderFailed(errorObject.errorMessage || "Unknown error");
			}, this));
		},

		handleOrderComplete: function(result) {
			this.logger.debug("order complete", arguments);

			// this.finalizeBlock
			// 	.bemRemoveModifier("loading")
			// 	.bemRemoveModifier("fail")
			// 	.bemAddModifier("success");

			Bridge.orderComplete(result);
		},

		handleOrderFailed: function(message) {
			this.logger.error("order failed", message);

			this.finalizeBlock
				.bemRemoveModifier("loading")
				.bemRemoveModifier("success")
				.bemAddModifier("fail");

			Bridge.orderFailed(message);
		},

		onBillwerkInitializationFail: function() {
			this.billwerk.initialized = false;
		},

		onBillwerkJs: function() {
			this.signupService = new BillwerkJS.Signup();
			this.paymentService = new BillwerkJS.Payment({
					publicApiKey : this.billwerk.pubKey,
					providerReturnUrl : this.billwerk.returnUrl
				},
				_.bind(this.onBillwerkInitialized, this),
				_.bind(this.onBillwerkInitializationFail, this)
			);
		}
	});
});
